import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Mixins } from 'vue-property-decorator';
import ActConfirm from "@/components/act-confirm";
import RightsAware from '@/lib/mixins/rights-aware';
import Icon from '../icon';

@Component
export default class ActionTd extends Mixins(RightsAware) {

  @Prop({type: Boolean, required: false, default: true}) readonly withDelete!: boolean;
  @Prop({type: Boolean, required: false, default: true}) readonly withEdit!: boolean;
  @Prop({type: Boolean, required: false, default: true}) readonly withOpen!: boolean;

  @Prop({type: String, required: false, default: "Voulez-vous supprimer cet élément ?"}) readonly confirmMessage!: string;

  forwardAction(action) {
    this.$emit(action);
  }

  render() {
    let classes = ["action-td"];
    return (
      <td class={classes.join(' ')}>
        {!this.isReadonly && this.withDelete && (
          <ActConfirm tag="a" class="is-small"
            confirmOptions={{
              message: this.confirmMessage,
              confirmButtonLabel: "Oui"
            }}
            onClick={() => this.forwardAction('delete')}
          >
            <Icon icon="trash" class="icon is-small"/>
          </ActConfirm>
        )}
        {!this.isReadonly && this.withEdit && <a class="is-small" onClick={() => this.forwardAction('edit')}><Icon icon="pen" class="icon is-small"/></a>}
        {(this.isReadonly && this.withOpen) && <a class="is-small" onClick={() => this.forwardAction('edit')}><Icon icon="eye" class="icon is-small"/></a>}
      </td>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3af754ba/action-td.tsx" });